// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export function buildActionName(event: any): any {
	return `${event.actionSubject} ${event.action}`;
}
